import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'components/pages/ResourceSetting/Widgets/TextField';

export default function MainCopyField({
  value,
  onChange,
  disabled,
  required,
}) {
  return (
    <TextField
      title="文案"
      description="建議90個字內要提到重點"
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      style={{ height: '150px' }}
    />
  );
}

MainCopyField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

MainCopyField.defaultProps = {
  value: '',
  onChange: () => {},
  disabled: false,
  required: true,
};
